/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

// Import Routes

import { Route as rootRoute } from './routes/__root'
import { Route as TestbedImport } from './routes/testbed'
import { Route as SignInImport } from './routes/sign-in'
import { Route as MfaVerifyImport } from './routes/mfa-verify'
import { Route as ForgotPasswordImport } from './routes/forgot-password'
import { Route as AppImport } from './routes/_app'
import { Route as AppIndexImport } from './routes/_app/index'
import { Route as AppSettingsImport } from './routes/_app/settings'
import { Route as AppHomeIndexImport } from './routes/_app/home/index'
import { Route as AppModuleidIndexImport } from './routes/_app/$module_id/index'
import { Route as IntegrationsQuickbooksCallbackImport } from './routes/integrations/quickbooks/callback'
import { Route as AppIntegrationsQuickbooksImport } from './routes/_app/integrations/quickbooks'
import { Route as AppSettingsUsersIndexImport } from './routes/_app/settings/users/index'
import { Route as AppSettingsUserGroupsIndexImport } from './routes/_app/settings/user-groups/index'
import { Route as AppSettingsOrgSettingsIndexImport } from './routes/_app/settings/org-settings/index'
import { Route as AppSettingsIntegrationsIndexImport } from './routes/_app/settings/integrations/index'
import { Route as AppSettingsGivingInfoIndexImport } from './routes/_app/settings/giving-info/index'
import { Route as AppSettingsIntegrationsQuickbooksImport } from './routes/_app/settings/integrations/quickbooks'
import { Route as AppModuleidEntitytypeidSegmentsImport } from './routes/_app/$module_id/$entity_type_id/segments'
import { Route as AppModuleidEntitytypeidEntityidImport } from './routes/_app/$module_id/$entity_type_id/$entity_id'
import { Route as AppSettingsUsersIdIndexImport } from './routes/_app/settings/users/$id/index'
import { Route as AppSettingsUserGroupsIdIndexImport } from './routes/_app/settings/user-groups/$id/index'
import { Route as AppModuleidEntitytypeidImportsIndexImport } from './routes/_app/$module_id/$entity_type_id/imports/index'
import { Route as AppModuleidEntitytypeidEntityidIndexImport } from './routes/_app/$module_id/$entity_type_id/$entity_id/index'
import { Route as AppModuleidEntitytypeidSegmentsManageImport } from './routes/_app/$module_id/$entity_type_id/segments/manage'
import { Route as AppModuleidEntitytypeidSegmentsSegmentidImport } from './routes/_app/$module_id/$entity_type_id/segments/$segment_id'
import { Route as AppModuleidEntitytypeidEntityidSidebarEditImport } from './routes/_app/$module_id/$entity_type_id/$entity_id/sidebar-edit'
import { Route as AppModuleidEntitytypeidEntityidTabsImport } from './routes/_app/$module_id/$entity_type_id/$entity_id/_tabs'
import { Route as AppModuleidEntitytypeidSegmentsSegmentidIndexImport } from './routes/_app/$module_id/$entity_type_id/segments/$segment_id/index'
import { Route as AppModuleidEntitytypeidEntityidDocumentTemplateIdImport } from './routes/_app/$module_id/$entity_type_id/$entity_id/document/$templateId'
import { Route as AppModuleidEntitytypeidEntityidTabsViewReportIndexImport } from './routes/_app/$module_id/$entity_type_id/$entity_id/_tabs/view-report/index'
import { Route as AppModuleidEntitytypeidEntityidTabsRelationshipsIndexImport } from './routes/_app/$module_id/$entity_type_id/$entity_id/_tabs/relationships/index'
import { Route as AppModuleidEntitytypeidEntityidTabsParametersIndexImport } from './routes/_app/$module_id/$entity_type_id/$entity_id/_tabs/parameters/index'
import { Route as AppModuleidEntitytypeidEntityidTabsOverviewIndexImport } from './routes/_app/$module_id/$entity_type_id/$entity_id/_tabs/overview/index'
import { Route as AppModuleidEntitytypeidEntityidTabsDetailsIndexImport } from './routes/_app/$module_id/$entity_type_id/$entity_id/_tabs/details/index'
import { Route as AppModuleidEntitytypeidEntityidTabsDesignIndexImport } from './routes/_app/$module_id/$entity_type_id/$entity_id/_tabs/design/index'
import { Route as AppModuleidEntitytypeidEntityidTabsDataSourcesIndexImport } from './routes/_app/$module_id/$entity_type_id/$entity_id/_tabs/data-sources/index'
import { Route as AppModuleidEntitytypeidEntityidTabsBudgetIndexImport } from './routes/_app/$module_id/$entity_type_id/$entity_id/_tabs/budget/index'
import { Route as AppModuleidEntitytypeidEntityidTabsAttendanceIndexImport } from './routes/_app/$module_id/$entity_type_id/$entity_id/_tabs/attendance/index'
import { Route as AppModuleidEntitytypeidEntityidTabsSubCollectionIndexImport } from './routes/_app/$module_id/$entity_type_id/$entity_id/_tabs/$subCollection/index'
import { Route as AppModuleidEntitytypeidSegmentsSegmentidCommunicationsTemplateidImport } from './routes/_app/$module_id/$entity_type_id/segments/$segment_id/communications/$template_id'
import { Route as AppModuleidEntitytypeidEntityidTabsSendDocumentTemplateIdImport } from './routes/_app/$module_id/$entity_type_id/$entity_id/_tabs/send/$documentTemplateId'
import { Route as AppModuleidEntitytypeidEntityidTabsDetailsDetailsTabImport } from './routes/_app/$module_id/$entity_type_id/$entity_id/_tabs/details/$detailsTab'
import { Route as AppModuleidEntitytypeidEntityidTabsDetailsDetailsTabIndexImport } from './routes/_app/$module_id/$entity_type_id/$entity_id/_tabs/details/$detailsTab/index'

// Create/Update Routes

const TestbedRoute = TestbedImport.update({
  id: '/testbed',
  path: '/testbed',
  getParentRoute: () => rootRoute,
} as any)

const SignInRoute = SignInImport.update({
  id: '/sign-in',
  path: '/sign-in',
  getParentRoute: () => rootRoute,
} as any)

const MfaVerifyRoute = MfaVerifyImport.update({
  id: '/mfa-verify',
  path: '/mfa-verify',
  getParentRoute: () => rootRoute,
} as any)

const ForgotPasswordRoute = ForgotPasswordImport.update({
  id: '/forgot-password',
  path: '/forgot-password',
  getParentRoute: () => rootRoute,
} as any)

const AppRoute = AppImport.update({
  id: '/_app',
  getParentRoute: () => rootRoute,
} as any)

const AppIndexRoute = AppIndexImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppRoute,
} as any)

const AppSettingsRoute = AppSettingsImport.update({
  id: '/settings',
  path: '/settings',
  getParentRoute: () => AppRoute,
} as any)

const AppHomeIndexRoute = AppHomeIndexImport.update({
  id: '/home/',
  path: '/home/',
  getParentRoute: () => AppRoute,
} as any)

const AppModuleidIndexRoute = AppModuleidIndexImport.update({
  id: '/$module_id/',
  path: '/$module_id/',
  getParentRoute: () => AppRoute,
} as any)

const IntegrationsQuickbooksCallbackRoute =
  IntegrationsQuickbooksCallbackImport.update({
    id: '/integrations/quickbooks/callback',
    path: '/integrations/quickbooks/callback',
    getParentRoute: () => rootRoute,
  } as any)

const AppIntegrationsQuickbooksRoute = AppIntegrationsQuickbooksImport.update({
  id: '/integrations/quickbooks',
  path: '/integrations/quickbooks',
  getParentRoute: () => AppRoute,
} as any)

const AppSettingsUsersIndexRoute = AppSettingsUsersIndexImport.update({
  id: '/users/',
  path: '/users/',
  getParentRoute: () => AppSettingsRoute,
} as any)

const AppSettingsUserGroupsIndexRoute = AppSettingsUserGroupsIndexImport.update(
  {
    id: '/user-groups/',
    path: '/user-groups/',
    getParentRoute: () => AppSettingsRoute,
  } as any,
)

const AppSettingsOrgSettingsIndexRoute =
  AppSettingsOrgSettingsIndexImport.update({
    id: '/org-settings/',
    path: '/org-settings/',
    getParentRoute: () => AppSettingsRoute,
  } as any)

const AppSettingsIntegrationsIndexRoute =
  AppSettingsIntegrationsIndexImport.update({
    id: '/integrations/',
    path: '/integrations/',
    getParentRoute: () => AppSettingsRoute,
  } as any)

const AppSettingsGivingInfoIndexRoute = AppSettingsGivingInfoIndexImport.update(
  {
    id: '/giving-info/',
    path: '/giving-info/',
    getParentRoute: () => AppSettingsRoute,
  } as any,
)

const AppSettingsIntegrationsQuickbooksRoute =
  AppSettingsIntegrationsQuickbooksImport.update({
    id: '/integrations/quickbooks',
    path: '/integrations/quickbooks',
    getParentRoute: () => AppSettingsRoute,
  } as any)

const AppModuleidEntitytypeidSegmentsRoute =
  AppModuleidEntitytypeidSegmentsImport.update({
    id: '/$module_id/$entity_type_id/segments',
    path: '/$module_id/$entity_type_id/segments',
    getParentRoute: () => AppRoute,
  } as any)

const AppModuleidEntitytypeidEntityidRoute =
  AppModuleidEntitytypeidEntityidImport.update({
    id: '/$module_id/$entity_type_id/$entity_id',
    path: '/$module_id/$entity_type_id/$entity_id',
    getParentRoute: () => AppRoute,
  } as any)

const AppSettingsUsersIdIndexRoute = AppSettingsUsersIdIndexImport.update({
  id: '/users/$id/',
  path: '/users/$id/',
  getParentRoute: () => AppSettingsRoute,
} as any)

const AppSettingsUserGroupsIdIndexRoute =
  AppSettingsUserGroupsIdIndexImport.update({
    id: '/user-groups/$id/',
    path: '/user-groups/$id/',
    getParentRoute: () => AppSettingsRoute,
  } as any)

const AppModuleidEntitytypeidImportsIndexRoute =
  AppModuleidEntitytypeidImportsIndexImport.update({
    id: '/$module_id/$entity_type_id/imports/',
    path: '/$module_id/$entity_type_id/imports/',
    getParentRoute: () => AppRoute,
  } as any)

const AppModuleidEntitytypeidEntityidIndexRoute =
  AppModuleidEntitytypeidEntityidIndexImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AppModuleidEntitytypeidEntityidRoute,
  } as any)

const AppModuleidEntitytypeidSegmentsManageRoute =
  AppModuleidEntitytypeidSegmentsManageImport.update({
    id: '/manage',
    path: '/manage',
    getParentRoute: () => AppModuleidEntitytypeidSegmentsRoute,
  } as any)

const AppModuleidEntitytypeidSegmentsSegmentidRoute =
  AppModuleidEntitytypeidSegmentsSegmentidImport.update({
    id: '/$segment_id',
    path: '/$segment_id',
    getParentRoute: () => AppModuleidEntitytypeidSegmentsRoute,
  } as any)

const AppModuleidEntitytypeidEntityidSidebarEditRoute =
  AppModuleidEntitytypeidEntityidSidebarEditImport.update({
    id: '/sidebar-edit',
    path: '/sidebar-edit',
    getParentRoute: () => AppModuleidEntitytypeidEntityidRoute,
  } as any)

const AppModuleidEntitytypeidEntityidTabsRoute =
  AppModuleidEntitytypeidEntityidTabsImport.update({
    id: '/_tabs',
    getParentRoute: () => AppModuleidEntitytypeidEntityidRoute,
  } as any)

const AppModuleidEntitytypeidSegmentsSegmentidIndexRoute =
  AppModuleidEntitytypeidSegmentsSegmentidIndexImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AppModuleidEntitytypeidSegmentsSegmentidRoute,
  } as any)

const AppModuleidEntitytypeidEntityidDocumentTemplateIdRoute =
  AppModuleidEntitytypeidEntityidDocumentTemplateIdImport.update({
    id: '/document/$templateId',
    path: '/document/$templateId',
    getParentRoute: () => AppModuleidEntitytypeidEntityidRoute,
  } as any)

const AppModuleidEntitytypeidEntityidTabsViewReportIndexRoute =
  AppModuleidEntitytypeidEntityidTabsViewReportIndexImport.update({
    id: '/view-report/',
    path: '/view-report/',
    getParentRoute: () => AppModuleidEntitytypeidEntityidTabsRoute,
  } as any)

const AppModuleidEntitytypeidEntityidTabsRelationshipsIndexRoute =
  AppModuleidEntitytypeidEntityidTabsRelationshipsIndexImport.update({
    id: '/relationships/',
    path: '/relationships/',
    getParentRoute: () => AppModuleidEntitytypeidEntityidTabsRoute,
  } as any)

const AppModuleidEntitytypeidEntityidTabsParametersIndexRoute =
  AppModuleidEntitytypeidEntityidTabsParametersIndexImport.update({
    id: '/parameters/',
    path: '/parameters/',
    getParentRoute: () => AppModuleidEntitytypeidEntityidTabsRoute,
  } as any)

const AppModuleidEntitytypeidEntityidTabsOverviewIndexRoute =
  AppModuleidEntitytypeidEntityidTabsOverviewIndexImport.update({
    id: '/overview/',
    path: '/overview/',
    getParentRoute: () => AppModuleidEntitytypeidEntityidTabsRoute,
  } as any)

const AppModuleidEntitytypeidEntityidTabsDetailsIndexRoute =
  AppModuleidEntitytypeidEntityidTabsDetailsIndexImport.update({
    id: '/details/',
    path: '/details/',
    getParentRoute: () => AppModuleidEntitytypeidEntityidTabsRoute,
  } as any)

const AppModuleidEntitytypeidEntityidTabsDesignIndexRoute =
  AppModuleidEntitytypeidEntityidTabsDesignIndexImport.update({
    id: '/design/',
    path: '/design/',
    getParentRoute: () => AppModuleidEntitytypeidEntityidTabsRoute,
  } as any)

const AppModuleidEntitytypeidEntityidTabsDataSourcesIndexRoute =
  AppModuleidEntitytypeidEntityidTabsDataSourcesIndexImport.update({
    id: '/data-sources/',
    path: '/data-sources/',
    getParentRoute: () => AppModuleidEntitytypeidEntityidTabsRoute,
  } as any)

const AppModuleidEntitytypeidEntityidTabsBudgetIndexRoute =
  AppModuleidEntitytypeidEntityidTabsBudgetIndexImport.update({
    id: '/budget/',
    path: '/budget/',
    getParentRoute: () => AppModuleidEntitytypeidEntityidTabsRoute,
  } as any)

const AppModuleidEntitytypeidEntityidTabsAttendanceIndexRoute =
  AppModuleidEntitytypeidEntityidTabsAttendanceIndexImport.update({
    id: '/attendance/',
    path: '/attendance/',
    getParentRoute: () => AppModuleidEntitytypeidEntityidTabsRoute,
  } as any)

const AppModuleidEntitytypeidEntityidTabsSubCollectionIndexRoute =
  AppModuleidEntitytypeidEntityidTabsSubCollectionIndexImport.update({
    id: '/$subCollection/',
    path: '/$subCollection/',
    getParentRoute: () => AppModuleidEntitytypeidEntityidTabsRoute,
  } as any)

const AppModuleidEntitytypeidSegmentsSegmentidCommunicationsTemplateidRoute =
  AppModuleidEntitytypeidSegmentsSegmentidCommunicationsTemplateidImport.update(
    {
      id: '/communications/$template_id',
      path: '/communications/$template_id',
      getParentRoute: () => AppModuleidEntitytypeidSegmentsSegmentidRoute,
    } as any,
  )

const AppModuleidEntitytypeidEntityidTabsSendDocumentTemplateIdRoute =
  AppModuleidEntitytypeidEntityidTabsSendDocumentTemplateIdImport.update({
    id: '/send/$documentTemplateId',
    path: '/send/$documentTemplateId',
    getParentRoute: () => AppModuleidEntitytypeidEntityidTabsRoute,
  } as any)

const AppModuleidEntitytypeidEntityidTabsDetailsDetailsTabRoute =
  AppModuleidEntitytypeidEntityidTabsDetailsDetailsTabImport.update({
    id: '/details/$detailsTab',
    path: '/details/$detailsTab',
    getParentRoute: () => AppModuleidEntitytypeidEntityidTabsRoute,
  } as any)

const AppModuleidEntitytypeidEntityidTabsDetailsDetailsTabIndexRoute =
  AppModuleidEntitytypeidEntityidTabsDetailsDetailsTabIndexImport.update({
    id: '/',
    path: '/',
    getParentRoute: () =>
      AppModuleidEntitytypeidEntityidTabsDetailsDetailsTabRoute,
  } as any)

// Populate the FileRoutesByPath interface

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/_app': {
      id: '/_app'
      path: ''
      fullPath: ''
      preLoaderRoute: typeof AppImport
      parentRoute: typeof rootRoute
    }
    '/forgot-password': {
      id: '/forgot-password'
      path: '/forgot-password'
      fullPath: '/forgot-password'
      preLoaderRoute: typeof ForgotPasswordImport
      parentRoute: typeof rootRoute
    }
    '/mfa-verify': {
      id: '/mfa-verify'
      path: '/mfa-verify'
      fullPath: '/mfa-verify'
      preLoaderRoute: typeof MfaVerifyImport
      parentRoute: typeof rootRoute
    }
    '/sign-in': {
      id: '/sign-in'
      path: '/sign-in'
      fullPath: '/sign-in'
      preLoaderRoute: typeof SignInImport
      parentRoute: typeof rootRoute
    }
    '/testbed': {
      id: '/testbed'
      path: '/testbed'
      fullPath: '/testbed'
      preLoaderRoute: typeof TestbedImport
      parentRoute: typeof rootRoute
    }
    '/_app/settings': {
      id: '/_app/settings'
      path: '/settings'
      fullPath: '/settings'
      preLoaderRoute: typeof AppSettingsImport
      parentRoute: typeof AppImport
    }
    '/_app/': {
      id: '/_app/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof AppIndexImport
      parentRoute: typeof AppImport
    }
    '/_app/integrations/quickbooks': {
      id: '/_app/integrations/quickbooks'
      path: '/integrations/quickbooks'
      fullPath: '/integrations/quickbooks'
      preLoaderRoute: typeof AppIntegrationsQuickbooksImport
      parentRoute: typeof AppImport
    }
    '/integrations/quickbooks/callback': {
      id: '/integrations/quickbooks/callback'
      path: '/integrations/quickbooks/callback'
      fullPath: '/integrations/quickbooks/callback'
      preLoaderRoute: typeof IntegrationsQuickbooksCallbackImport
      parentRoute: typeof rootRoute
    }
    '/_app/$module_id/': {
      id: '/_app/$module_id/'
      path: '/$module_id'
      fullPath: '/$module_id'
      preLoaderRoute: typeof AppModuleidIndexImport
      parentRoute: typeof AppImport
    }
    '/_app/home/': {
      id: '/_app/home/'
      path: '/home'
      fullPath: '/home'
      preLoaderRoute: typeof AppHomeIndexImport
      parentRoute: typeof AppImport
    }
    '/_app/$module_id/$entity_type_id/$entity_id': {
      id: '/_app/$module_id/$entity_type_id/$entity_id'
      path: '/$module_id/$entity_type_id/$entity_id'
      fullPath: '/$module_id/$entity_type_id/$entity_id'
      preLoaderRoute: typeof AppModuleidEntitytypeidEntityidImport
      parentRoute: typeof AppImport
    }
    '/_app/$module_id/$entity_type_id/segments': {
      id: '/_app/$module_id/$entity_type_id/segments'
      path: '/$module_id/$entity_type_id/segments'
      fullPath: '/$module_id/$entity_type_id/segments'
      preLoaderRoute: typeof AppModuleidEntitytypeidSegmentsImport
      parentRoute: typeof AppImport
    }
    '/_app/settings/integrations/quickbooks': {
      id: '/_app/settings/integrations/quickbooks'
      path: '/integrations/quickbooks'
      fullPath: '/settings/integrations/quickbooks'
      preLoaderRoute: typeof AppSettingsIntegrationsQuickbooksImport
      parentRoute: typeof AppSettingsImport
    }
    '/_app/settings/giving-info/': {
      id: '/_app/settings/giving-info/'
      path: '/giving-info'
      fullPath: '/settings/giving-info'
      preLoaderRoute: typeof AppSettingsGivingInfoIndexImport
      parentRoute: typeof AppSettingsImport
    }
    '/_app/settings/integrations/': {
      id: '/_app/settings/integrations/'
      path: '/integrations'
      fullPath: '/settings/integrations'
      preLoaderRoute: typeof AppSettingsIntegrationsIndexImport
      parentRoute: typeof AppSettingsImport
    }
    '/_app/settings/org-settings/': {
      id: '/_app/settings/org-settings/'
      path: '/org-settings'
      fullPath: '/settings/org-settings'
      preLoaderRoute: typeof AppSettingsOrgSettingsIndexImport
      parentRoute: typeof AppSettingsImport
    }
    '/_app/settings/user-groups/': {
      id: '/_app/settings/user-groups/'
      path: '/user-groups'
      fullPath: '/settings/user-groups'
      preLoaderRoute: typeof AppSettingsUserGroupsIndexImport
      parentRoute: typeof AppSettingsImport
    }
    '/_app/settings/users/': {
      id: '/_app/settings/users/'
      path: '/users'
      fullPath: '/settings/users'
      preLoaderRoute: typeof AppSettingsUsersIndexImport
      parentRoute: typeof AppSettingsImport
    }
    '/_app/$module_id/$entity_type_id/$entity_id/_tabs': {
      id: '/_app/$module_id/$entity_type_id/$entity_id/_tabs'
      path: ''
      fullPath: '/$module_id/$entity_type_id/$entity_id'
      preLoaderRoute: typeof AppModuleidEntitytypeidEntityidTabsImport
      parentRoute: typeof AppModuleidEntitytypeidEntityidImport
    }
    '/_app/$module_id/$entity_type_id/$entity_id/sidebar-edit': {
      id: '/_app/$module_id/$entity_type_id/$entity_id/sidebar-edit'
      path: '/sidebar-edit'
      fullPath: '/$module_id/$entity_type_id/$entity_id/sidebar-edit'
      preLoaderRoute: typeof AppModuleidEntitytypeidEntityidSidebarEditImport
      parentRoute: typeof AppModuleidEntitytypeidEntityidImport
    }
    '/_app/$module_id/$entity_type_id/segments/$segment_id': {
      id: '/_app/$module_id/$entity_type_id/segments/$segment_id'
      path: '/$segment_id'
      fullPath: '/$module_id/$entity_type_id/segments/$segment_id'
      preLoaderRoute: typeof AppModuleidEntitytypeidSegmentsSegmentidImport
      parentRoute: typeof AppModuleidEntitytypeidSegmentsImport
    }
    '/_app/$module_id/$entity_type_id/segments/manage': {
      id: '/_app/$module_id/$entity_type_id/segments/manage'
      path: '/manage'
      fullPath: '/$module_id/$entity_type_id/segments/manage'
      preLoaderRoute: typeof AppModuleidEntitytypeidSegmentsManageImport
      parentRoute: typeof AppModuleidEntitytypeidSegmentsImport
    }
    '/_app/$module_id/$entity_type_id/$entity_id/': {
      id: '/_app/$module_id/$entity_type_id/$entity_id/'
      path: '/'
      fullPath: '/$module_id/$entity_type_id/$entity_id/'
      preLoaderRoute: typeof AppModuleidEntitytypeidEntityidIndexImport
      parentRoute: typeof AppModuleidEntitytypeidEntityidImport
    }
    '/_app/$module_id/$entity_type_id/imports/': {
      id: '/_app/$module_id/$entity_type_id/imports/'
      path: '/$module_id/$entity_type_id/imports'
      fullPath: '/$module_id/$entity_type_id/imports'
      preLoaderRoute: typeof AppModuleidEntitytypeidImportsIndexImport
      parentRoute: typeof AppImport
    }
    '/_app/settings/user-groups/$id/': {
      id: '/_app/settings/user-groups/$id/'
      path: '/user-groups/$id'
      fullPath: '/settings/user-groups/$id'
      preLoaderRoute: typeof AppSettingsUserGroupsIdIndexImport
      parentRoute: typeof AppSettingsImport
    }
    '/_app/settings/users/$id/': {
      id: '/_app/settings/users/$id/'
      path: '/users/$id'
      fullPath: '/settings/users/$id'
      preLoaderRoute: typeof AppSettingsUsersIdIndexImport
      parentRoute: typeof AppSettingsImport
    }
    '/_app/$module_id/$entity_type_id/$entity_id/document/$templateId': {
      id: '/_app/$module_id/$entity_type_id/$entity_id/document/$templateId'
      path: '/document/$templateId'
      fullPath: '/$module_id/$entity_type_id/$entity_id/document/$templateId'
      preLoaderRoute: typeof AppModuleidEntitytypeidEntityidDocumentTemplateIdImport
      parentRoute: typeof AppModuleidEntitytypeidEntityidImport
    }
    '/_app/$module_id/$entity_type_id/segments/$segment_id/': {
      id: '/_app/$module_id/$entity_type_id/segments/$segment_id/'
      path: '/'
      fullPath: '/$module_id/$entity_type_id/segments/$segment_id/'
      preLoaderRoute: typeof AppModuleidEntitytypeidSegmentsSegmentidIndexImport
      parentRoute: typeof AppModuleidEntitytypeidSegmentsSegmentidImport
    }
    '/_app/$module_id/$entity_type_id/$entity_id/_tabs/details/$detailsTab': {
      id: '/_app/$module_id/$entity_type_id/$entity_id/_tabs/details/$detailsTab'
      path: '/details/$detailsTab'
      fullPath: '/$module_id/$entity_type_id/$entity_id/details/$detailsTab'
      preLoaderRoute: typeof AppModuleidEntitytypeidEntityidTabsDetailsDetailsTabImport
      parentRoute: typeof AppModuleidEntitytypeidEntityidTabsImport
    }
    '/_app/$module_id/$entity_type_id/$entity_id/_tabs/send/$documentTemplateId': {
      id: '/_app/$module_id/$entity_type_id/$entity_id/_tabs/send/$documentTemplateId'
      path: '/send/$documentTemplateId'
      fullPath: '/$module_id/$entity_type_id/$entity_id/send/$documentTemplateId'
      preLoaderRoute: typeof AppModuleidEntitytypeidEntityidTabsSendDocumentTemplateIdImport
      parentRoute: typeof AppModuleidEntitytypeidEntityidTabsImport
    }
    '/_app/$module_id/$entity_type_id/segments/$segment_id/communications/$template_id': {
      id: '/_app/$module_id/$entity_type_id/segments/$segment_id/communications/$template_id'
      path: '/communications/$template_id'
      fullPath: '/$module_id/$entity_type_id/segments/$segment_id/communications/$template_id'
      preLoaderRoute: typeof AppModuleidEntitytypeidSegmentsSegmentidCommunicationsTemplateidImport
      parentRoute: typeof AppModuleidEntitytypeidSegmentsSegmentidImport
    }
    '/_app/$module_id/$entity_type_id/$entity_id/_tabs/$subCollection/': {
      id: '/_app/$module_id/$entity_type_id/$entity_id/_tabs/$subCollection/'
      path: '/$subCollection'
      fullPath: '/$module_id/$entity_type_id/$entity_id/$subCollection'
      preLoaderRoute: typeof AppModuleidEntitytypeidEntityidTabsSubCollectionIndexImport
      parentRoute: typeof AppModuleidEntitytypeidEntityidTabsImport
    }
    '/_app/$module_id/$entity_type_id/$entity_id/_tabs/attendance/': {
      id: '/_app/$module_id/$entity_type_id/$entity_id/_tabs/attendance/'
      path: '/attendance'
      fullPath: '/$module_id/$entity_type_id/$entity_id/attendance'
      preLoaderRoute: typeof AppModuleidEntitytypeidEntityidTabsAttendanceIndexImport
      parentRoute: typeof AppModuleidEntitytypeidEntityidTabsImport
    }
    '/_app/$module_id/$entity_type_id/$entity_id/_tabs/budget/': {
      id: '/_app/$module_id/$entity_type_id/$entity_id/_tabs/budget/'
      path: '/budget'
      fullPath: '/$module_id/$entity_type_id/$entity_id/budget'
      preLoaderRoute: typeof AppModuleidEntitytypeidEntityidTabsBudgetIndexImport
      parentRoute: typeof AppModuleidEntitytypeidEntityidTabsImport
    }
    '/_app/$module_id/$entity_type_id/$entity_id/_tabs/data-sources/': {
      id: '/_app/$module_id/$entity_type_id/$entity_id/_tabs/data-sources/'
      path: '/data-sources'
      fullPath: '/$module_id/$entity_type_id/$entity_id/data-sources'
      preLoaderRoute: typeof AppModuleidEntitytypeidEntityidTabsDataSourcesIndexImport
      parentRoute: typeof AppModuleidEntitytypeidEntityidTabsImport
    }
    '/_app/$module_id/$entity_type_id/$entity_id/_tabs/design/': {
      id: '/_app/$module_id/$entity_type_id/$entity_id/_tabs/design/'
      path: '/design'
      fullPath: '/$module_id/$entity_type_id/$entity_id/design'
      preLoaderRoute: typeof AppModuleidEntitytypeidEntityidTabsDesignIndexImport
      parentRoute: typeof AppModuleidEntitytypeidEntityidTabsImport
    }
    '/_app/$module_id/$entity_type_id/$entity_id/_tabs/details/': {
      id: '/_app/$module_id/$entity_type_id/$entity_id/_tabs/details/'
      path: '/details'
      fullPath: '/$module_id/$entity_type_id/$entity_id/details'
      preLoaderRoute: typeof AppModuleidEntitytypeidEntityidTabsDetailsIndexImport
      parentRoute: typeof AppModuleidEntitytypeidEntityidTabsImport
    }
    '/_app/$module_id/$entity_type_id/$entity_id/_tabs/overview/': {
      id: '/_app/$module_id/$entity_type_id/$entity_id/_tabs/overview/'
      path: '/overview'
      fullPath: '/$module_id/$entity_type_id/$entity_id/overview'
      preLoaderRoute: typeof AppModuleidEntitytypeidEntityidTabsOverviewIndexImport
      parentRoute: typeof AppModuleidEntitytypeidEntityidTabsImport
    }
    '/_app/$module_id/$entity_type_id/$entity_id/_tabs/parameters/': {
      id: '/_app/$module_id/$entity_type_id/$entity_id/_tabs/parameters/'
      path: '/parameters'
      fullPath: '/$module_id/$entity_type_id/$entity_id/parameters'
      preLoaderRoute: typeof AppModuleidEntitytypeidEntityidTabsParametersIndexImport
      parentRoute: typeof AppModuleidEntitytypeidEntityidTabsImport
    }
    '/_app/$module_id/$entity_type_id/$entity_id/_tabs/relationships/': {
      id: '/_app/$module_id/$entity_type_id/$entity_id/_tabs/relationships/'
      path: '/relationships'
      fullPath: '/$module_id/$entity_type_id/$entity_id/relationships'
      preLoaderRoute: typeof AppModuleidEntitytypeidEntityidTabsRelationshipsIndexImport
      parentRoute: typeof AppModuleidEntitytypeidEntityidTabsImport
    }
    '/_app/$module_id/$entity_type_id/$entity_id/_tabs/view-report/': {
      id: '/_app/$module_id/$entity_type_id/$entity_id/_tabs/view-report/'
      path: '/view-report'
      fullPath: '/$module_id/$entity_type_id/$entity_id/view-report'
      preLoaderRoute: typeof AppModuleidEntitytypeidEntityidTabsViewReportIndexImport
      parentRoute: typeof AppModuleidEntitytypeidEntityidTabsImport
    }
    '/_app/$module_id/$entity_type_id/$entity_id/_tabs/details/$detailsTab/': {
      id: '/_app/$module_id/$entity_type_id/$entity_id/_tabs/details/$detailsTab/'
      path: '/'
      fullPath: '/$module_id/$entity_type_id/$entity_id/details/$detailsTab/'
      preLoaderRoute: typeof AppModuleidEntitytypeidEntityidTabsDetailsDetailsTabIndexImport
      parentRoute: typeof AppModuleidEntitytypeidEntityidTabsDetailsDetailsTabImport
    }
  }
}

// Create and export the route tree

interface AppSettingsRouteChildren {
  AppSettingsIntegrationsQuickbooksRoute: typeof AppSettingsIntegrationsQuickbooksRoute
  AppSettingsGivingInfoIndexRoute: typeof AppSettingsGivingInfoIndexRoute
  AppSettingsIntegrationsIndexRoute: typeof AppSettingsIntegrationsIndexRoute
  AppSettingsOrgSettingsIndexRoute: typeof AppSettingsOrgSettingsIndexRoute
  AppSettingsUserGroupsIndexRoute: typeof AppSettingsUserGroupsIndexRoute
  AppSettingsUsersIndexRoute: typeof AppSettingsUsersIndexRoute
  AppSettingsUserGroupsIdIndexRoute: typeof AppSettingsUserGroupsIdIndexRoute
  AppSettingsUsersIdIndexRoute: typeof AppSettingsUsersIdIndexRoute
}

const AppSettingsRouteChildren: AppSettingsRouteChildren = {
  AppSettingsIntegrationsQuickbooksRoute:
    AppSettingsIntegrationsQuickbooksRoute,
  AppSettingsGivingInfoIndexRoute: AppSettingsGivingInfoIndexRoute,
  AppSettingsIntegrationsIndexRoute: AppSettingsIntegrationsIndexRoute,
  AppSettingsOrgSettingsIndexRoute: AppSettingsOrgSettingsIndexRoute,
  AppSettingsUserGroupsIndexRoute: AppSettingsUserGroupsIndexRoute,
  AppSettingsUsersIndexRoute: AppSettingsUsersIndexRoute,
  AppSettingsUserGroupsIdIndexRoute: AppSettingsUserGroupsIdIndexRoute,
  AppSettingsUsersIdIndexRoute: AppSettingsUsersIdIndexRoute,
}

const AppSettingsRouteWithChildren = AppSettingsRoute._addFileChildren(
  AppSettingsRouteChildren,
)

interface AppModuleidEntitytypeidEntityidTabsDetailsDetailsTabRouteChildren {
  AppModuleidEntitytypeidEntityidTabsDetailsDetailsTabIndexRoute: typeof AppModuleidEntitytypeidEntityidTabsDetailsDetailsTabIndexRoute
}

const AppModuleidEntitytypeidEntityidTabsDetailsDetailsTabRouteChildren: AppModuleidEntitytypeidEntityidTabsDetailsDetailsTabRouteChildren =
  {
    AppModuleidEntitytypeidEntityidTabsDetailsDetailsTabIndexRoute:
      AppModuleidEntitytypeidEntityidTabsDetailsDetailsTabIndexRoute,
  }

const AppModuleidEntitytypeidEntityidTabsDetailsDetailsTabRouteWithChildren =
  AppModuleidEntitytypeidEntityidTabsDetailsDetailsTabRoute._addFileChildren(
    AppModuleidEntitytypeidEntityidTabsDetailsDetailsTabRouteChildren,
  )

interface AppModuleidEntitytypeidEntityidTabsRouteChildren {
  AppModuleidEntitytypeidEntityidTabsDetailsDetailsTabRoute: typeof AppModuleidEntitytypeidEntityidTabsDetailsDetailsTabRouteWithChildren
  AppModuleidEntitytypeidEntityidTabsSendDocumentTemplateIdRoute: typeof AppModuleidEntitytypeidEntityidTabsSendDocumentTemplateIdRoute
  AppModuleidEntitytypeidEntityidTabsSubCollectionIndexRoute: typeof AppModuleidEntitytypeidEntityidTabsSubCollectionIndexRoute
  AppModuleidEntitytypeidEntityidTabsAttendanceIndexRoute: typeof AppModuleidEntitytypeidEntityidTabsAttendanceIndexRoute
  AppModuleidEntitytypeidEntityidTabsBudgetIndexRoute: typeof AppModuleidEntitytypeidEntityidTabsBudgetIndexRoute
  AppModuleidEntitytypeidEntityidTabsDataSourcesIndexRoute: typeof AppModuleidEntitytypeidEntityidTabsDataSourcesIndexRoute
  AppModuleidEntitytypeidEntityidTabsDesignIndexRoute: typeof AppModuleidEntitytypeidEntityidTabsDesignIndexRoute
  AppModuleidEntitytypeidEntityidTabsDetailsIndexRoute: typeof AppModuleidEntitytypeidEntityidTabsDetailsIndexRoute
  AppModuleidEntitytypeidEntityidTabsOverviewIndexRoute: typeof AppModuleidEntitytypeidEntityidTabsOverviewIndexRoute
  AppModuleidEntitytypeidEntityidTabsParametersIndexRoute: typeof AppModuleidEntitytypeidEntityidTabsParametersIndexRoute
  AppModuleidEntitytypeidEntityidTabsRelationshipsIndexRoute: typeof AppModuleidEntitytypeidEntityidTabsRelationshipsIndexRoute
  AppModuleidEntitytypeidEntityidTabsViewReportIndexRoute: typeof AppModuleidEntitytypeidEntityidTabsViewReportIndexRoute
}

const AppModuleidEntitytypeidEntityidTabsRouteChildren: AppModuleidEntitytypeidEntityidTabsRouteChildren =
  {
    AppModuleidEntitytypeidEntityidTabsDetailsDetailsTabRoute:
      AppModuleidEntitytypeidEntityidTabsDetailsDetailsTabRouteWithChildren,
    AppModuleidEntitytypeidEntityidTabsSendDocumentTemplateIdRoute:
      AppModuleidEntitytypeidEntityidTabsSendDocumentTemplateIdRoute,
    AppModuleidEntitytypeidEntityidTabsSubCollectionIndexRoute:
      AppModuleidEntitytypeidEntityidTabsSubCollectionIndexRoute,
    AppModuleidEntitytypeidEntityidTabsAttendanceIndexRoute:
      AppModuleidEntitytypeidEntityidTabsAttendanceIndexRoute,
    AppModuleidEntitytypeidEntityidTabsBudgetIndexRoute:
      AppModuleidEntitytypeidEntityidTabsBudgetIndexRoute,
    AppModuleidEntitytypeidEntityidTabsDataSourcesIndexRoute:
      AppModuleidEntitytypeidEntityidTabsDataSourcesIndexRoute,
    AppModuleidEntitytypeidEntityidTabsDesignIndexRoute:
      AppModuleidEntitytypeidEntityidTabsDesignIndexRoute,
    AppModuleidEntitytypeidEntityidTabsDetailsIndexRoute:
      AppModuleidEntitytypeidEntityidTabsDetailsIndexRoute,
    AppModuleidEntitytypeidEntityidTabsOverviewIndexRoute:
      AppModuleidEntitytypeidEntityidTabsOverviewIndexRoute,
    AppModuleidEntitytypeidEntityidTabsParametersIndexRoute:
      AppModuleidEntitytypeidEntityidTabsParametersIndexRoute,
    AppModuleidEntitytypeidEntityidTabsRelationshipsIndexRoute:
      AppModuleidEntitytypeidEntityidTabsRelationshipsIndexRoute,
    AppModuleidEntitytypeidEntityidTabsViewReportIndexRoute:
      AppModuleidEntitytypeidEntityidTabsViewReportIndexRoute,
  }

const AppModuleidEntitytypeidEntityidTabsRouteWithChildren =
  AppModuleidEntitytypeidEntityidTabsRoute._addFileChildren(
    AppModuleidEntitytypeidEntityidTabsRouteChildren,
  )

interface AppModuleidEntitytypeidEntityidRouteChildren {
  AppModuleidEntitytypeidEntityidTabsRoute: typeof AppModuleidEntitytypeidEntityidTabsRouteWithChildren
  AppModuleidEntitytypeidEntityidSidebarEditRoute: typeof AppModuleidEntitytypeidEntityidSidebarEditRoute
  AppModuleidEntitytypeidEntityidIndexRoute: typeof AppModuleidEntitytypeidEntityidIndexRoute
  AppModuleidEntitytypeidEntityidDocumentTemplateIdRoute: typeof AppModuleidEntitytypeidEntityidDocumentTemplateIdRoute
}

const AppModuleidEntitytypeidEntityidRouteChildren: AppModuleidEntitytypeidEntityidRouteChildren =
  {
    AppModuleidEntitytypeidEntityidTabsRoute:
      AppModuleidEntitytypeidEntityidTabsRouteWithChildren,
    AppModuleidEntitytypeidEntityidSidebarEditRoute:
      AppModuleidEntitytypeidEntityidSidebarEditRoute,
    AppModuleidEntitytypeidEntityidIndexRoute:
      AppModuleidEntitytypeidEntityidIndexRoute,
    AppModuleidEntitytypeidEntityidDocumentTemplateIdRoute:
      AppModuleidEntitytypeidEntityidDocumentTemplateIdRoute,
  }

const AppModuleidEntitytypeidEntityidRouteWithChildren =
  AppModuleidEntitytypeidEntityidRoute._addFileChildren(
    AppModuleidEntitytypeidEntityidRouteChildren,
  )

interface AppModuleidEntitytypeidSegmentsSegmentidRouteChildren {
  AppModuleidEntitytypeidSegmentsSegmentidIndexRoute: typeof AppModuleidEntitytypeidSegmentsSegmentidIndexRoute
  AppModuleidEntitytypeidSegmentsSegmentidCommunicationsTemplateidRoute: typeof AppModuleidEntitytypeidSegmentsSegmentidCommunicationsTemplateidRoute
}

const AppModuleidEntitytypeidSegmentsSegmentidRouteChildren: AppModuleidEntitytypeidSegmentsSegmentidRouteChildren =
  {
    AppModuleidEntitytypeidSegmentsSegmentidIndexRoute:
      AppModuleidEntitytypeidSegmentsSegmentidIndexRoute,
    AppModuleidEntitytypeidSegmentsSegmentidCommunicationsTemplateidRoute:
      AppModuleidEntitytypeidSegmentsSegmentidCommunicationsTemplateidRoute,
  }

const AppModuleidEntitytypeidSegmentsSegmentidRouteWithChildren =
  AppModuleidEntitytypeidSegmentsSegmentidRoute._addFileChildren(
    AppModuleidEntitytypeidSegmentsSegmentidRouteChildren,
  )

interface AppModuleidEntitytypeidSegmentsRouteChildren {
  AppModuleidEntitytypeidSegmentsSegmentidRoute: typeof AppModuleidEntitytypeidSegmentsSegmentidRouteWithChildren
  AppModuleidEntitytypeidSegmentsManageRoute: typeof AppModuleidEntitytypeidSegmentsManageRoute
}

const AppModuleidEntitytypeidSegmentsRouteChildren: AppModuleidEntitytypeidSegmentsRouteChildren =
  {
    AppModuleidEntitytypeidSegmentsSegmentidRoute:
      AppModuleidEntitytypeidSegmentsSegmentidRouteWithChildren,
    AppModuleidEntitytypeidSegmentsManageRoute:
      AppModuleidEntitytypeidSegmentsManageRoute,
  }

const AppModuleidEntitytypeidSegmentsRouteWithChildren =
  AppModuleidEntitytypeidSegmentsRoute._addFileChildren(
    AppModuleidEntitytypeidSegmentsRouteChildren,
  )

interface AppRouteChildren {
  AppSettingsRoute: typeof AppSettingsRouteWithChildren
  AppIndexRoute: typeof AppIndexRoute
  AppIntegrationsQuickbooksRoute: typeof AppIntegrationsQuickbooksRoute
  AppModuleidIndexRoute: typeof AppModuleidIndexRoute
  AppHomeIndexRoute: typeof AppHomeIndexRoute
  AppModuleidEntitytypeidEntityidRoute: typeof AppModuleidEntitytypeidEntityidRouteWithChildren
  AppModuleidEntitytypeidSegmentsRoute: typeof AppModuleidEntitytypeidSegmentsRouteWithChildren
  AppModuleidEntitytypeidImportsIndexRoute: typeof AppModuleidEntitytypeidImportsIndexRoute
}

const AppRouteChildren: AppRouteChildren = {
  AppSettingsRoute: AppSettingsRouteWithChildren,
  AppIndexRoute: AppIndexRoute,
  AppIntegrationsQuickbooksRoute: AppIntegrationsQuickbooksRoute,
  AppModuleidIndexRoute: AppModuleidIndexRoute,
  AppHomeIndexRoute: AppHomeIndexRoute,
  AppModuleidEntitytypeidEntityidRoute:
    AppModuleidEntitytypeidEntityidRouteWithChildren,
  AppModuleidEntitytypeidSegmentsRoute:
    AppModuleidEntitytypeidSegmentsRouteWithChildren,
  AppModuleidEntitytypeidImportsIndexRoute:
    AppModuleidEntitytypeidImportsIndexRoute,
}

const AppRouteWithChildren = AppRoute._addFileChildren(AppRouteChildren)

export interface FileRoutesByFullPath {
  '': typeof AppRouteWithChildren
  '/forgot-password': typeof ForgotPasswordRoute
  '/mfa-verify': typeof MfaVerifyRoute
  '/sign-in': typeof SignInRoute
  '/testbed': typeof TestbedRoute
  '/settings': typeof AppSettingsRouteWithChildren
  '/': typeof AppIndexRoute
  '/integrations/quickbooks': typeof AppIntegrationsQuickbooksRoute
  '/integrations/quickbooks/callback': typeof IntegrationsQuickbooksCallbackRoute
  '/$module_id': typeof AppModuleidIndexRoute
  '/home': typeof AppHomeIndexRoute
  '/$module_id/$entity_type_id/$entity_id': typeof AppModuleidEntitytypeidEntityidTabsRouteWithChildren
  '/$module_id/$entity_type_id/segments': typeof AppModuleidEntitytypeidSegmentsRouteWithChildren
  '/settings/integrations/quickbooks': typeof AppSettingsIntegrationsQuickbooksRoute
  '/settings/giving-info': typeof AppSettingsGivingInfoIndexRoute
  '/settings/integrations': typeof AppSettingsIntegrationsIndexRoute
  '/settings/org-settings': typeof AppSettingsOrgSettingsIndexRoute
  '/settings/user-groups': typeof AppSettingsUserGroupsIndexRoute
  '/settings/users': typeof AppSettingsUsersIndexRoute
  '/$module_id/$entity_type_id/$entity_id/sidebar-edit': typeof AppModuleidEntitytypeidEntityidSidebarEditRoute
  '/$module_id/$entity_type_id/segments/$segment_id': typeof AppModuleidEntitytypeidSegmentsSegmentidRouteWithChildren
  '/$module_id/$entity_type_id/segments/manage': typeof AppModuleidEntitytypeidSegmentsManageRoute
  '/$module_id/$entity_type_id/$entity_id/': typeof AppModuleidEntitytypeidEntityidIndexRoute
  '/$module_id/$entity_type_id/imports': typeof AppModuleidEntitytypeidImportsIndexRoute
  '/settings/user-groups/$id': typeof AppSettingsUserGroupsIdIndexRoute
  '/settings/users/$id': typeof AppSettingsUsersIdIndexRoute
  '/$module_id/$entity_type_id/$entity_id/document/$templateId': typeof AppModuleidEntitytypeidEntityidDocumentTemplateIdRoute
  '/$module_id/$entity_type_id/segments/$segment_id/': typeof AppModuleidEntitytypeidSegmentsSegmentidIndexRoute
  '/$module_id/$entity_type_id/$entity_id/details/$detailsTab': typeof AppModuleidEntitytypeidEntityidTabsDetailsDetailsTabRouteWithChildren
  '/$module_id/$entity_type_id/$entity_id/send/$documentTemplateId': typeof AppModuleidEntitytypeidEntityidTabsSendDocumentTemplateIdRoute
  '/$module_id/$entity_type_id/segments/$segment_id/communications/$template_id': typeof AppModuleidEntitytypeidSegmentsSegmentidCommunicationsTemplateidRoute
  '/$module_id/$entity_type_id/$entity_id/$subCollection': typeof AppModuleidEntitytypeidEntityidTabsSubCollectionIndexRoute
  '/$module_id/$entity_type_id/$entity_id/attendance': typeof AppModuleidEntitytypeidEntityidTabsAttendanceIndexRoute
  '/$module_id/$entity_type_id/$entity_id/budget': typeof AppModuleidEntitytypeidEntityidTabsBudgetIndexRoute
  '/$module_id/$entity_type_id/$entity_id/data-sources': typeof AppModuleidEntitytypeidEntityidTabsDataSourcesIndexRoute
  '/$module_id/$entity_type_id/$entity_id/design': typeof AppModuleidEntitytypeidEntityidTabsDesignIndexRoute
  '/$module_id/$entity_type_id/$entity_id/details': typeof AppModuleidEntitytypeidEntityidTabsDetailsIndexRoute
  '/$module_id/$entity_type_id/$entity_id/overview': typeof AppModuleidEntitytypeidEntityidTabsOverviewIndexRoute
  '/$module_id/$entity_type_id/$entity_id/parameters': typeof AppModuleidEntitytypeidEntityidTabsParametersIndexRoute
  '/$module_id/$entity_type_id/$entity_id/relationships': typeof AppModuleidEntitytypeidEntityidTabsRelationshipsIndexRoute
  '/$module_id/$entity_type_id/$entity_id/view-report': typeof AppModuleidEntitytypeidEntityidTabsViewReportIndexRoute
  '/$module_id/$entity_type_id/$entity_id/details/$detailsTab/': typeof AppModuleidEntitytypeidEntityidTabsDetailsDetailsTabIndexRoute
}

export interface FileRoutesByTo {
  '/forgot-password': typeof ForgotPasswordRoute
  '/mfa-verify': typeof MfaVerifyRoute
  '/sign-in': typeof SignInRoute
  '/testbed': typeof TestbedRoute
  '/settings': typeof AppSettingsRouteWithChildren
  '/': typeof AppIndexRoute
  '/integrations/quickbooks': typeof AppIntegrationsQuickbooksRoute
  '/integrations/quickbooks/callback': typeof IntegrationsQuickbooksCallbackRoute
  '/$module_id': typeof AppModuleidIndexRoute
  '/home': typeof AppHomeIndexRoute
  '/$module_id/$entity_type_id/segments': typeof AppModuleidEntitytypeidSegmentsRouteWithChildren
  '/settings/integrations/quickbooks': typeof AppSettingsIntegrationsQuickbooksRoute
  '/settings/giving-info': typeof AppSettingsGivingInfoIndexRoute
  '/settings/integrations': typeof AppSettingsIntegrationsIndexRoute
  '/settings/org-settings': typeof AppSettingsOrgSettingsIndexRoute
  '/settings/user-groups': typeof AppSettingsUserGroupsIndexRoute
  '/settings/users': typeof AppSettingsUsersIndexRoute
  '/$module_id/$entity_type_id/$entity_id': typeof AppModuleidEntitytypeidEntityidIndexRoute
  '/$module_id/$entity_type_id/$entity_id/sidebar-edit': typeof AppModuleidEntitytypeidEntityidSidebarEditRoute
  '/$module_id/$entity_type_id/segments/manage': typeof AppModuleidEntitytypeidSegmentsManageRoute
  '/$module_id/$entity_type_id/imports': typeof AppModuleidEntitytypeidImportsIndexRoute
  '/settings/user-groups/$id': typeof AppSettingsUserGroupsIdIndexRoute
  '/settings/users/$id': typeof AppSettingsUsersIdIndexRoute
  '/$module_id/$entity_type_id/$entity_id/document/$templateId': typeof AppModuleidEntitytypeidEntityidDocumentTemplateIdRoute
  '/$module_id/$entity_type_id/segments/$segment_id': typeof AppModuleidEntitytypeidSegmentsSegmentidIndexRoute
  '/$module_id/$entity_type_id/$entity_id/send/$documentTemplateId': typeof AppModuleidEntitytypeidEntityidTabsSendDocumentTemplateIdRoute
  '/$module_id/$entity_type_id/segments/$segment_id/communications/$template_id': typeof AppModuleidEntitytypeidSegmentsSegmentidCommunicationsTemplateidRoute
  '/$module_id/$entity_type_id/$entity_id/$subCollection': typeof AppModuleidEntitytypeidEntityidTabsSubCollectionIndexRoute
  '/$module_id/$entity_type_id/$entity_id/attendance': typeof AppModuleidEntitytypeidEntityidTabsAttendanceIndexRoute
  '/$module_id/$entity_type_id/$entity_id/budget': typeof AppModuleidEntitytypeidEntityidTabsBudgetIndexRoute
  '/$module_id/$entity_type_id/$entity_id/data-sources': typeof AppModuleidEntitytypeidEntityidTabsDataSourcesIndexRoute
  '/$module_id/$entity_type_id/$entity_id/design': typeof AppModuleidEntitytypeidEntityidTabsDesignIndexRoute
  '/$module_id/$entity_type_id/$entity_id/details': typeof AppModuleidEntitytypeidEntityidTabsDetailsIndexRoute
  '/$module_id/$entity_type_id/$entity_id/overview': typeof AppModuleidEntitytypeidEntityidTabsOverviewIndexRoute
  '/$module_id/$entity_type_id/$entity_id/parameters': typeof AppModuleidEntitytypeidEntityidTabsParametersIndexRoute
  '/$module_id/$entity_type_id/$entity_id/relationships': typeof AppModuleidEntitytypeidEntityidTabsRelationshipsIndexRoute
  '/$module_id/$entity_type_id/$entity_id/view-report': typeof AppModuleidEntitytypeidEntityidTabsViewReportIndexRoute
  '/$module_id/$entity_type_id/$entity_id/details/$detailsTab': typeof AppModuleidEntitytypeidEntityidTabsDetailsDetailsTabIndexRoute
}

export interface FileRoutesById {
  __root__: typeof rootRoute
  '/_app': typeof AppRouteWithChildren
  '/forgot-password': typeof ForgotPasswordRoute
  '/mfa-verify': typeof MfaVerifyRoute
  '/sign-in': typeof SignInRoute
  '/testbed': typeof TestbedRoute
  '/_app/settings': typeof AppSettingsRouteWithChildren
  '/_app/': typeof AppIndexRoute
  '/_app/integrations/quickbooks': typeof AppIntegrationsQuickbooksRoute
  '/integrations/quickbooks/callback': typeof IntegrationsQuickbooksCallbackRoute
  '/_app/$module_id/': typeof AppModuleidIndexRoute
  '/_app/home/': typeof AppHomeIndexRoute
  '/_app/$module_id/$entity_type_id/$entity_id': typeof AppModuleidEntitytypeidEntityidRouteWithChildren
  '/_app/$module_id/$entity_type_id/segments': typeof AppModuleidEntitytypeidSegmentsRouteWithChildren
  '/_app/settings/integrations/quickbooks': typeof AppSettingsIntegrationsQuickbooksRoute
  '/_app/settings/giving-info/': typeof AppSettingsGivingInfoIndexRoute
  '/_app/settings/integrations/': typeof AppSettingsIntegrationsIndexRoute
  '/_app/settings/org-settings/': typeof AppSettingsOrgSettingsIndexRoute
  '/_app/settings/user-groups/': typeof AppSettingsUserGroupsIndexRoute
  '/_app/settings/users/': typeof AppSettingsUsersIndexRoute
  '/_app/$module_id/$entity_type_id/$entity_id/_tabs': typeof AppModuleidEntitytypeidEntityidTabsRouteWithChildren
  '/_app/$module_id/$entity_type_id/$entity_id/sidebar-edit': typeof AppModuleidEntitytypeidEntityidSidebarEditRoute
  '/_app/$module_id/$entity_type_id/segments/$segment_id': typeof AppModuleidEntitytypeidSegmentsSegmentidRouteWithChildren
  '/_app/$module_id/$entity_type_id/segments/manage': typeof AppModuleidEntitytypeidSegmentsManageRoute
  '/_app/$module_id/$entity_type_id/$entity_id/': typeof AppModuleidEntitytypeidEntityidIndexRoute
  '/_app/$module_id/$entity_type_id/imports/': typeof AppModuleidEntitytypeidImportsIndexRoute
  '/_app/settings/user-groups/$id/': typeof AppSettingsUserGroupsIdIndexRoute
  '/_app/settings/users/$id/': typeof AppSettingsUsersIdIndexRoute
  '/_app/$module_id/$entity_type_id/$entity_id/document/$templateId': typeof AppModuleidEntitytypeidEntityidDocumentTemplateIdRoute
  '/_app/$module_id/$entity_type_id/segments/$segment_id/': typeof AppModuleidEntitytypeidSegmentsSegmentidIndexRoute
  '/_app/$module_id/$entity_type_id/$entity_id/_tabs/details/$detailsTab': typeof AppModuleidEntitytypeidEntityidTabsDetailsDetailsTabRouteWithChildren
  '/_app/$module_id/$entity_type_id/$entity_id/_tabs/send/$documentTemplateId': typeof AppModuleidEntitytypeidEntityidTabsSendDocumentTemplateIdRoute
  '/_app/$module_id/$entity_type_id/segments/$segment_id/communications/$template_id': typeof AppModuleidEntitytypeidSegmentsSegmentidCommunicationsTemplateidRoute
  '/_app/$module_id/$entity_type_id/$entity_id/_tabs/$subCollection/': typeof AppModuleidEntitytypeidEntityidTabsSubCollectionIndexRoute
  '/_app/$module_id/$entity_type_id/$entity_id/_tabs/attendance/': typeof AppModuleidEntitytypeidEntityidTabsAttendanceIndexRoute
  '/_app/$module_id/$entity_type_id/$entity_id/_tabs/budget/': typeof AppModuleidEntitytypeidEntityidTabsBudgetIndexRoute
  '/_app/$module_id/$entity_type_id/$entity_id/_tabs/data-sources/': typeof AppModuleidEntitytypeidEntityidTabsDataSourcesIndexRoute
  '/_app/$module_id/$entity_type_id/$entity_id/_tabs/design/': typeof AppModuleidEntitytypeidEntityidTabsDesignIndexRoute
  '/_app/$module_id/$entity_type_id/$entity_id/_tabs/details/': typeof AppModuleidEntitytypeidEntityidTabsDetailsIndexRoute
  '/_app/$module_id/$entity_type_id/$entity_id/_tabs/overview/': typeof AppModuleidEntitytypeidEntityidTabsOverviewIndexRoute
  '/_app/$module_id/$entity_type_id/$entity_id/_tabs/parameters/': typeof AppModuleidEntitytypeidEntityidTabsParametersIndexRoute
  '/_app/$module_id/$entity_type_id/$entity_id/_tabs/relationships/': typeof AppModuleidEntitytypeidEntityidTabsRelationshipsIndexRoute
  '/_app/$module_id/$entity_type_id/$entity_id/_tabs/view-report/': typeof AppModuleidEntitytypeidEntityidTabsViewReportIndexRoute
  '/_app/$module_id/$entity_type_id/$entity_id/_tabs/details/$detailsTab/': typeof AppModuleidEntitytypeidEntityidTabsDetailsDetailsTabIndexRoute
}

export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | ''
    | '/forgot-password'
    | '/mfa-verify'
    | '/sign-in'
    | '/testbed'
    | '/settings'
    | '/'
    | '/integrations/quickbooks'
    | '/integrations/quickbooks/callback'
    | '/$module_id'
    | '/home'
    | '/$module_id/$entity_type_id/$entity_id'
    | '/$module_id/$entity_type_id/segments'
    | '/settings/integrations/quickbooks'
    | '/settings/giving-info'
    | '/settings/integrations'
    | '/settings/org-settings'
    | '/settings/user-groups'
    | '/settings/users'
    | '/$module_id/$entity_type_id/$entity_id/sidebar-edit'
    | '/$module_id/$entity_type_id/segments/$segment_id'
    | '/$module_id/$entity_type_id/segments/manage'
    | '/$module_id/$entity_type_id/$entity_id/'
    | '/$module_id/$entity_type_id/imports'
    | '/settings/user-groups/$id'
    | '/settings/users/$id'
    | '/$module_id/$entity_type_id/$entity_id/document/$templateId'
    | '/$module_id/$entity_type_id/segments/$segment_id/'
    | '/$module_id/$entity_type_id/$entity_id/details/$detailsTab'
    | '/$module_id/$entity_type_id/$entity_id/send/$documentTemplateId'
    | '/$module_id/$entity_type_id/segments/$segment_id/communications/$template_id'
    | '/$module_id/$entity_type_id/$entity_id/$subCollection'
    | '/$module_id/$entity_type_id/$entity_id/attendance'
    | '/$module_id/$entity_type_id/$entity_id/budget'
    | '/$module_id/$entity_type_id/$entity_id/data-sources'
    | '/$module_id/$entity_type_id/$entity_id/design'
    | '/$module_id/$entity_type_id/$entity_id/details'
    | '/$module_id/$entity_type_id/$entity_id/overview'
    | '/$module_id/$entity_type_id/$entity_id/parameters'
    | '/$module_id/$entity_type_id/$entity_id/relationships'
    | '/$module_id/$entity_type_id/$entity_id/view-report'
    | '/$module_id/$entity_type_id/$entity_id/details/$detailsTab/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/forgot-password'
    | '/mfa-verify'
    | '/sign-in'
    | '/testbed'
    | '/settings'
    | '/'
    | '/integrations/quickbooks'
    | '/integrations/quickbooks/callback'
    | '/$module_id'
    | '/home'
    | '/$module_id/$entity_type_id/segments'
    | '/settings/integrations/quickbooks'
    | '/settings/giving-info'
    | '/settings/integrations'
    | '/settings/org-settings'
    | '/settings/user-groups'
    | '/settings/users'
    | '/$module_id/$entity_type_id/$entity_id'
    | '/$module_id/$entity_type_id/$entity_id/sidebar-edit'
    | '/$module_id/$entity_type_id/segments/manage'
    | '/$module_id/$entity_type_id/imports'
    | '/settings/user-groups/$id'
    | '/settings/users/$id'
    | '/$module_id/$entity_type_id/$entity_id/document/$templateId'
    | '/$module_id/$entity_type_id/segments/$segment_id'
    | '/$module_id/$entity_type_id/$entity_id/send/$documentTemplateId'
    | '/$module_id/$entity_type_id/segments/$segment_id/communications/$template_id'
    | '/$module_id/$entity_type_id/$entity_id/$subCollection'
    | '/$module_id/$entity_type_id/$entity_id/attendance'
    | '/$module_id/$entity_type_id/$entity_id/budget'
    | '/$module_id/$entity_type_id/$entity_id/data-sources'
    | '/$module_id/$entity_type_id/$entity_id/design'
    | '/$module_id/$entity_type_id/$entity_id/details'
    | '/$module_id/$entity_type_id/$entity_id/overview'
    | '/$module_id/$entity_type_id/$entity_id/parameters'
    | '/$module_id/$entity_type_id/$entity_id/relationships'
    | '/$module_id/$entity_type_id/$entity_id/view-report'
    | '/$module_id/$entity_type_id/$entity_id/details/$detailsTab'
  id:
    | '__root__'
    | '/_app'
    | '/forgot-password'
    | '/mfa-verify'
    | '/sign-in'
    | '/testbed'
    | '/_app/settings'
    | '/_app/'
    | '/_app/integrations/quickbooks'
    | '/integrations/quickbooks/callback'
    | '/_app/$module_id/'
    | '/_app/home/'
    | '/_app/$module_id/$entity_type_id/$entity_id'
    | '/_app/$module_id/$entity_type_id/segments'
    | '/_app/settings/integrations/quickbooks'
    | '/_app/settings/giving-info/'
    | '/_app/settings/integrations/'
    | '/_app/settings/org-settings/'
    | '/_app/settings/user-groups/'
    | '/_app/settings/users/'
    | '/_app/$module_id/$entity_type_id/$entity_id/_tabs'
    | '/_app/$module_id/$entity_type_id/$entity_id/sidebar-edit'
    | '/_app/$module_id/$entity_type_id/segments/$segment_id'
    | '/_app/$module_id/$entity_type_id/segments/manage'
    | '/_app/$module_id/$entity_type_id/$entity_id/'
    | '/_app/$module_id/$entity_type_id/imports/'
    | '/_app/settings/user-groups/$id/'
    | '/_app/settings/users/$id/'
    | '/_app/$module_id/$entity_type_id/$entity_id/document/$templateId'
    | '/_app/$module_id/$entity_type_id/segments/$segment_id/'
    | '/_app/$module_id/$entity_type_id/$entity_id/_tabs/details/$detailsTab'
    | '/_app/$module_id/$entity_type_id/$entity_id/_tabs/send/$documentTemplateId'
    | '/_app/$module_id/$entity_type_id/segments/$segment_id/communications/$template_id'
    | '/_app/$module_id/$entity_type_id/$entity_id/_tabs/$subCollection/'
    | '/_app/$module_id/$entity_type_id/$entity_id/_tabs/attendance/'
    | '/_app/$module_id/$entity_type_id/$entity_id/_tabs/budget/'
    | '/_app/$module_id/$entity_type_id/$entity_id/_tabs/data-sources/'
    | '/_app/$module_id/$entity_type_id/$entity_id/_tabs/design/'
    | '/_app/$module_id/$entity_type_id/$entity_id/_tabs/details/'
    | '/_app/$module_id/$entity_type_id/$entity_id/_tabs/overview/'
    | '/_app/$module_id/$entity_type_id/$entity_id/_tabs/parameters/'
    | '/_app/$module_id/$entity_type_id/$entity_id/_tabs/relationships/'
    | '/_app/$module_id/$entity_type_id/$entity_id/_tabs/view-report/'
    | '/_app/$module_id/$entity_type_id/$entity_id/_tabs/details/$detailsTab/'
  fileRoutesById: FileRoutesById
}

export interface RootRouteChildren {
  AppRoute: typeof AppRouteWithChildren
  ForgotPasswordRoute: typeof ForgotPasswordRoute
  MfaVerifyRoute: typeof MfaVerifyRoute
  SignInRoute: typeof SignInRoute
  TestbedRoute: typeof TestbedRoute
  IntegrationsQuickbooksCallbackRoute: typeof IntegrationsQuickbooksCallbackRoute
}

const rootRouteChildren: RootRouteChildren = {
  AppRoute: AppRouteWithChildren,
  ForgotPasswordRoute: ForgotPasswordRoute,
  MfaVerifyRoute: MfaVerifyRoute,
  SignInRoute: SignInRoute,
  TestbedRoute: TestbedRoute,
  IntegrationsQuickbooksCallbackRoute: IntegrationsQuickbooksCallbackRoute,
}

export const routeTree = rootRoute
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()

/* ROUTE_MANIFEST_START
{
  "routes": {
    "__root__": {
      "filePath": "__root.tsx",
      "children": [
        "/_app",
        "/forgot-password",
        "/mfa-verify",
        "/sign-in",
        "/testbed",
        "/integrations/quickbooks/callback"
      ]
    },
    "/_app": {
      "filePath": "_app.tsx",
      "children": [
        "/_app/settings",
        "/_app/",
        "/_app/integrations/quickbooks",
        "/_app/$module_id/",
        "/_app/home/",
        "/_app/$module_id/$entity_type_id/$entity_id",
        "/_app/$module_id/$entity_type_id/segments",
        "/_app/$module_id/$entity_type_id/imports/"
      ]
    },
    "/forgot-password": {
      "filePath": "forgot-password.tsx"
    },
    "/mfa-verify": {
      "filePath": "mfa-verify.tsx"
    },
    "/sign-in": {
      "filePath": "sign-in.tsx"
    },
    "/testbed": {
      "filePath": "testbed.tsx"
    },
    "/_app/settings": {
      "filePath": "_app/settings.tsx",
      "parent": "/_app",
      "children": [
        "/_app/settings/integrations/quickbooks",
        "/_app/settings/giving-info/",
        "/_app/settings/integrations/",
        "/_app/settings/org-settings/",
        "/_app/settings/user-groups/",
        "/_app/settings/users/",
        "/_app/settings/user-groups/$id/",
        "/_app/settings/users/$id/"
      ]
    },
    "/_app/": {
      "filePath": "_app/index.tsx",
      "parent": "/_app"
    },
    "/_app/integrations/quickbooks": {
      "filePath": "_app/integrations/quickbooks.tsx",
      "parent": "/_app"
    },
    "/integrations/quickbooks/callback": {
      "filePath": "integrations/quickbooks/callback.tsx"
    },
    "/_app/$module_id/": {
      "filePath": "_app/$module_id/index.tsx",
      "parent": "/_app"
    },
    "/_app/home/": {
      "filePath": "_app/home/index.tsx",
      "parent": "/_app"
    },
    "/_app/$module_id/$entity_type_id/$entity_id": {
      "filePath": "_app/$module_id/$entity_type_id/$entity_id.tsx",
      "parent": "/_app",
      "children": [
        "/_app/$module_id/$entity_type_id/$entity_id/_tabs",
        "/_app/$module_id/$entity_type_id/$entity_id/sidebar-edit",
        "/_app/$module_id/$entity_type_id/$entity_id/",
        "/_app/$module_id/$entity_type_id/$entity_id/document/$templateId"
      ]
    },
    "/_app/$module_id/$entity_type_id/segments": {
      "filePath": "_app/$module_id/$entity_type_id/segments.tsx",
      "parent": "/_app",
      "children": [
        "/_app/$module_id/$entity_type_id/segments/$segment_id",
        "/_app/$module_id/$entity_type_id/segments/manage"
      ]
    },
    "/_app/settings/integrations/quickbooks": {
      "filePath": "_app/settings/integrations/quickbooks.tsx",
      "parent": "/_app/settings"
    },
    "/_app/settings/giving-info/": {
      "filePath": "_app/settings/giving-info/index.tsx",
      "parent": "/_app/settings"
    },
    "/_app/settings/integrations/": {
      "filePath": "_app/settings/integrations/index.tsx",
      "parent": "/_app/settings"
    },
    "/_app/settings/org-settings/": {
      "filePath": "_app/settings/org-settings/index.tsx",
      "parent": "/_app/settings"
    },
    "/_app/settings/user-groups/": {
      "filePath": "_app/settings/user-groups/index.tsx",
      "parent": "/_app/settings"
    },
    "/_app/settings/users/": {
      "filePath": "_app/settings/users/index.tsx",
      "parent": "/_app/settings"
    },
    "/_app/$module_id/$entity_type_id/$entity_id/_tabs": {
      "filePath": "_app/$module_id/$entity_type_id/$entity_id/_tabs.tsx",
      "parent": "/_app/$module_id/$entity_type_id/$entity_id",
      "children": [
        "/_app/$module_id/$entity_type_id/$entity_id/_tabs/details/$detailsTab",
        "/_app/$module_id/$entity_type_id/$entity_id/_tabs/send/$documentTemplateId",
        "/_app/$module_id/$entity_type_id/$entity_id/_tabs/$subCollection/",
        "/_app/$module_id/$entity_type_id/$entity_id/_tabs/attendance/",
        "/_app/$module_id/$entity_type_id/$entity_id/_tabs/budget/",
        "/_app/$module_id/$entity_type_id/$entity_id/_tabs/data-sources/",
        "/_app/$module_id/$entity_type_id/$entity_id/_tabs/design/",
        "/_app/$module_id/$entity_type_id/$entity_id/_tabs/details/",
        "/_app/$module_id/$entity_type_id/$entity_id/_tabs/overview/",
        "/_app/$module_id/$entity_type_id/$entity_id/_tabs/parameters/",
        "/_app/$module_id/$entity_type_id/$entity_id/_tabs/relationships/",
        "/_app/$module_id/$entity_type_id/$entity_id/_tabs/view-report/"
      ]
    },
    "/_app/$module_id/$entity_type_id/$entity_id/sidebar-edit": {
      "filePath": "_app/$module_id/$entity_type_id/$entity_id/sidebar-edit.tsx",
      "parent": "/_app/$module_id/$entity_type_id/$entity_id"
    },
    "/_app/$module_id/$entity_type_id/segments/$segment_id": {
      "filePath": "_app/$module_id/$entity_type_id/segments/$segment_id.tsx",
      "parent": "/_app/$module_id/$entity_type_id/segments",
      "children": [
        "/_app/$module_id/$entity_type_id/segments/$segment_id/",
        "/_app/$module_id/$entity_type_id/segments/$segment_id/communications/$template_id"
      ]
    },
    "/_app/$module_id/$entity_type_id/segments/manage": {
      "filePath": "_app/$module_id/$entity_type_id/segments/manage.tsx",
      "parent": "/_app/$module_id/$entity_type_id/segments"
    },
    "/_app/$module_id/$entity_type_id/$entity_id/": {
      "filePath": "_app/$module_id/$entity_type_id/$entity_id/index.tsx",
      "parent": "/_app/$module_id/$entity_type_id/$entity_id"
    },
    "/_app/$module_id/$entity_type_id/imports/": {
      "filePath": "_app/$module_id/$entity_type_id/imports/index.tsx",
      "parent": "/_app"
    },
    "/_app/settings/user-groups/$id/": {
      "filePath": "_app/settings/user-groups/$id/index.tsx",
      "parent": "/_app/settings"
    },
    "/_app/settings/users/$id/": {
      "filePath": "_app/settings/users/$id/index.tsx",
      "parent": "/_app/settings"
    },
    "/_app/$module_id/$entity_type_id/$entity_id/document/$templateId": {
      "filePath": "_app/$module_id/$entity_type_id/$entity_id/document/$templateId.tsx",
      "parent": "/_app/$module_id/$entity_type_id/$entity_id"
    },
    "/_app/$module_id/$entity_type_id/segments/$segment_id/": {
      "filePath": "_app/$module_id/$entity_type_id/segments/$segment_id/index.tsx",
      "parent": "/_app/$module_id/$entity_type_id/segments/$segment_id"
    },
    "/_app/$module_id/$entity_type_id/$entity_id/_tabs/details/$detailsTab": {
      "filePath": "_app/$module_id/$entity_type_id/$entity_id/_tabs/details/$detailsTab.tsx",
      "parent": "/_app/$module_id/$entity_type_id/$entity_id/_tabs",
      "children": [
        "/_app/$module_id/$entity_type_id/$entity_id/_tabs/details/$detailsTab/"
      ]
    },
    "/_app/$module_id/$entity_type_id/$entity_id/_tabs/send/$documentTemplateId": {
      "filePath": "_app/$module_id/$entity_type_id/$entity_id/_tabs/send/$documentTemplateId.tsx",
      "parent": "/_app/$module_id/$entity_type_id/$entity_id/_tabs"
    },
    "/_app/$module_id/$entity_type_id/segments/$segment_id/communications/$template_id": {
      "filePath": "_app/$module_id/$entity_type_id/segments/$segment_id/communications/$template_id.tsx",
      "parent": "/_app/$module_id/$entity_type_id/segments/$segment_id"
    },
    "/_app/$module_id/$entity_type_id/$entity_id/_tabs/$subCollection/": {
      "filePath": "_app/$module_id/$entity_type_id/$entity_id/_tabs/$subCollection/index.tsx",
      "parent": "/_app/$module_id/$entity_type_id/$entity_id/_tabs"
    },
    "/_app/$module_id/$entity_type_id/$entity_id/_tabs/attendance/": {
      "filePath": "_app/$module_id/$entity_type_id/$entity_id/_tabs/attendance/index.tsx",
      "parent": "/_app/$module_id/$entity_type_id/$entity_id/_tabs"
    },
    "/_app/$module_id/$entity_type_id/$entity_id/_tabs/budget/": {
      "filePath": "_app/$module_id/$entity_type_id/$entity_id/_tabs/budget/index.tsx",
      "parent": "/_app/$module_id/$entity_type_id/$entity_id/_tabs"
    },
    "/_app/$module_id/$entity_type_id/$entity_id/_tabs/data-sources/": {
      "filePath": "_app/$module_id/$entity_type_id/$entity_id/_tabs/data-sources/index.tsx",
      "parent": "/_app/$module_id/$entity_type_id/$entity_id/_tabs"
    },
    "/_app/$module_id/$entity_type_id/$entity_id/_tabs/design/": {
      "filePath": "_app/$module_id/$entity_type_id/$entity_id/_tabs/design/index.tsx",
      "parent": "/_app/$module_id/$entity_type_id/$entity_id/_tabs"
    },
    "/_app/$module_id/$entity_type_id/$entity_id/_tabs/details/": {
      "filePath": "_app/$module_id/$entity_type_id/$entity_id/_tabs/details/index.tsx",
      "parent": "/_app/$module_id/$entity_type_id/$entity_id/_tabs"
    },
    "/_app/$module_id/$entity_type_id/$entity_id/_tabs/overview/": {
      "filePath": "_app/$module_id/$entity_type_id/$entity_id/_tabs/overview/index.tsx",
      "parent": "/_app/$module_id/$entity_type_id/$entity_id/_tabs"
    },
    "/_app/$module_id/$entity_type_id/$entity_id/_tabs/parameters/": {
      "filePath": "_app/$module_id/$entity_type_id/$entity_id/_tabs/parameters/index.tsx",
      "parent": "/_app/$module_id/$entity_type_id/$entity_id/_tabs"
    },
    "/_app/$module_id/$entity_type_id/$entity_id/_tabs/relationships/": {
      "filePath": "_app/$module_id/$entity_type_id/$entity_id/_tabs/relationships/index.tsx",
      "parent": "/_app/$module_id/$entity_type_id/$entity_id/_tabs"
    },
    "/_app/$module_id/$entity_type_id/$entity_id/_tabs/view-report/": {
      "filePath": "_app/$module_id/$entity_type_id/$entity_id/_tabs/view-report/index.tsx",
      "parent": "/_app/$module_id/$entity_type_id/$entity_id/_tabs"
    },
    "/_app/$module_id/$entity_type_id/$entity_id/_tabs/details/$detailsTab/": {
      "filePath": "_app/$module_id/$entity_type_id/$entity_id/_tabs/details/$detailsTab/index.tsx",
      "parent": "/_app/$module_id/$entity_type_id/$entity_id/_tabs/details/$detailsTab"
    }
  }
}
ROUTE_MANIFEST_END */
